module.exports = __webpack_public_path__ + "static/media/Leia Organa.303bc390.jpg";